var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlignCenterVertical = function SvgIconAlignCenterVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.875 11H3a1 1 0 1 0 0 2h.875v6.5c0 .966.784 1.75 1.75 1.75h3.75a1.75 1.75 0 0 0 1.75-1.75V13h1.75v4.25c0 .966.784 1.75 1.75 1.75h3.75a1.75 1.75 0 0 0 1.75-1.75V13H21a1 1 0 1 0 0-2h-.875V6.75A1.75 1.75 0 0 0 18.375 5h-3.75a1.75 1.75 0 0 0-1.75 1.75V11h-1.75V4.5a1.75 1.75 0 0 0-1.75-1.75h-3.75a1.75 1.75 0 0 0-1.75 1.75zm2-6.25h3.25v14.5h-3.25zM18.125 7h-3.25v10h3.25z",
    clipRule: "evenodd"
  })));
};
export default SvgIconAlignCenterVertical;